// api.js
import axios from 'axios';
axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

const api = axios.create({
    //baseURL: '//azbot.ddns.net/api', // Ajusta la URL base según tu configuración
    baseURL: 'https://azbot.ddns.net/api', // Ajusta la URL base según tu configuración
    
    withCredentials: true, // Permite enviar cookies o credenciales
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Interceptor para adjuntar el token en cada solicitud
api.interceptors.request.use( config => {
    
    const accessToken = sessionStorage.getItem('authToken');

    console.log('request  accessToken>> ', accessToken);

    if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // Asegurar que los headers CORS estén presentes (opcional, pero no afecta el servidor)
    config.headers['Access-Control-Allow-Origin'] = '*'; // Esto no es necesario en el cliente, pero lo agregamos por claridad
    config.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
    config.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization';


    return config;
}, error => {
    return Promise.reject(error);
});

// Interceptor para manejar errores de CORS en las respuestas
api.interceptors.response.use(
    (response) => {
        // Verificar si la respuesta incluye el header Access-Control-Allow-Origin
        if (!response.headers['access-control-allow-origin']) {
            console.warn('El servidor no incluyó el header Access-Control-Allow-Origin en la respuesta.');
        }
        return response;
    },
    (error) => {
        // Manejar errores de CORS
        if (error.response && error.response.status === 0) {
            console.error('Error de CORS: No se pudo conectar al servidor.');
        }
        return Promise.reject(error);
    }
);

export default api;
